<template>
  <div>
    <div class="grid-default min-h-screen gap-y-4 lg:gap-y-24">
      <ArticleListItem
        v-for="item in data"
        :key="item.id"
        :data="item"
        class="col-span-6 md:col-span-3 lg:col-span-4"
      />
    </div>

    <div v-if="isLoading" class="py-10 text-center">
      <Spinner class="mx-auto mt-10" />
    </div>

    <div v-else-if="loadMore" class="mt-8 text-center lg:mt-24">
      <Button
        :label="$t('articles.more')"
        icon
        :icon-class="isDesktop ? 'rotate-90' : ''"
        @click="store.fetchArticles(locale, categoryID)"
      />
    </div>

    <div v-else-if="isEmpty">
      <div class="my-10 text-center text-4xl">{{ $t('articles.empty') }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useBlogStore } from '~/stores/BlogStore'
import type { ArticleRecord } from '~/types/generated'

const { isDesktop } = useDevice()
const { locale } = useI18n()
const store = useBlogStore()
const route = useRoute()
const categoryID = computed(() => store.getCategoryByName(route.query.category)?.id)

defineProps({
  data: {
    type: Array as PropType<ArticleRecord[]>,
    default: () => []
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  loadMore: {
    type: Boolean,
    default: false
  },
  isEmpty: {
    type: Boolean,
    default: false
  }
})
</script>
